export default "__VITE_ASSET__DRbPvAIO__"